<div class="content" *ngIf="textConfig$ | async as config">
  <router-outlet />
</div>
